import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import ButtonLink from 'components/Buttons/Link';
import { useTranslation } from 'react-i18next';
import { useSubscriptionProps } from '../../Billing/useSubscriptionProps';
import TwoColumnsCardSidebar from 'components/TwoColumnsCardSidebar';
import { UserAddLicences } from './UserAddLicences';

export function UserAddLicencesPage() {
  const { t } = useTranslation(['userSettings']);
  const subscriptionProps = useSubscriptionProps();
  return (
    <TwoColumnsCardSidebar.Container>
      <ButtonLink
        to="/settings/school-subscription/licenses"
        minimal
        icon={ArrowLeftIcon}
        tw="mb-4"
      >
        {t('userSettings:schoolSubscription.goToLicenses')}
      </ButtonLink>
      <UserAddLicences {...subscriptionProps} />
    </TwoColumnsCardSidebar.Container>
  );
}
